import { PrintTemplatesGroup } from "features/PrintTemplatesGroup/PrintTemplatesGroup";
import { PrintTemplates } from "features/PrintTemplates/PrintTemplates";

import styles from "./styles.module.scss";

export const PrintTemplatesPage = (): JSX.Element => (
  <div className={styles.main}>
    <PrintTemplatesGroup />
    <PrintTemplates />
  </div>
);
